import axios from 'axios'
var token = localStorage.getItem('bfToken');
const api = axios.create({
	//baseURL: 'http://localhost:8002/'
	// produção 
	//baseURL: 'https://ws.brandful.com.br/'
	// staging 
	baseURL: process.env.REACT_APP_API_URL,
	timeout: 0
});

if (token) {
	api.defaults.headers.common['Authorization'] = token;
}
export default api